export const LOGIN_STORAGE_KEY = "login-form-email";
export const POST_LOGIN_REDIRECT_KEY = "post-login-redirect";
export const SIGNUP_STORAGE_KEY = "signupLocation";
export const CHECKOUT_SUCCESS_REDIRECT_KEY = "checkout-success-redirect";
export const DEFAULT_SELECTED_TERM = "annual";
export const UPGRADE_ON_WEBSITE_KEY = "videoscribe-website-upgrade";
